import { useInfiniteQuery } from '@tanstack/react-query';
import { useInstitutionStore } from '@/modules/auth/presentation/store/institution.store';
import { authContainer } from '@/modules/auth/di/container';
import { sinaremReportsContainer } from '../../di/container';

const PAGE_SIZE = 20;

export function useStudentRanking(editionId: string) {
  const { institutionName } = useInstitutionStore();
  const isAuthenticated = institutionName
    ? authContainer.repository.isAuthenticated(institutionName)
    : false;

  return useInfiniteQuery({
    queryKey: [
      'sinarem-reports',
      'student-ranking',
      institutionName,
      editionId,
    ],
    queryFn: ({ pageParam }) =>
      sinaremReportsContainer.repository.getStudentRanking(
        editionId,
        pageParam,
        PAGE_SIZE,
      ),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      const loaded = allPages.reduce(
        (sum, page) => sum + page.ranking.length,
        0,
      );
      return loaded < lastPage.total ? allPages.length + 1 : undefined;
    },
    enabled: isAuthenticated && !!editionId,
    retry: false,
  });
}
